import { Box, BoxProps, ColorOptions, Loader, LoaderNew, ModBox, Spacer, SpacerNew, Text, TextProps } from '@jfs/ui-new'
import { Button } from '../../components/AdminButton'
import { useCallback, useEffect, useRef, useState } from 'react'
import { SearchByMid } from '../../components/ActionMenu/SearchByMid'
import { useLazyApiData, useStores } from '../../data/store'
import { isAccessible } from '../../utils'
import { Details } from './Details'

const RiskConfig = () => {
  const { searchMid, fetchMidConfig, updateMidConfig, accessConfig } = useStores((store) => ({
    updateMidConfig: store.merchantPayoutConfig.updateMidPayoutConfig,
    searchMid: store.searchMid,
    fetchMidConfig: store.merchantPayoutConfig.fetchMidPayoutConfig,
    accessConfig: store.user.getAccessConfig(['ess', 'risk_config']),
  }))
  const abortControllerRef = useRef<AbortController>()
  const [lazyFetchSearchMidApi, { state: searchMidState, data: searchMerchantApiData }] = useLazyApiData(searchMid)
  const [lazyFetchMidPayoutConfig, { state: fetchMidConfigState, data: midConfigData }] = useLazyApiData(fetchMidConfig)
  const [lazyUpdateMidPayoutConfig, { state: updateState }] = useLazyApiData(updateMidConfig)
  const [searchString, setSearchString] = useState(false)

  useEffect(() => {
    if (fetchMidConfigState === 'fulfilled') {
      lazyUpdateMidPayoutConfig(searchString, {
        ...midConfigData,
        settlementOnHold: midConfigData?.settlementOnHold === false ? true : false,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchMidConfigState])

  const onSearchByMidClick = useCallback(() => {
    lazyFetchSearchMidApi(searchString, 'Entity ID', 'ALL', abortControllerRef.current)
  }, [lazyFetchSearchMidApi, searchString])

  const onMidChange = (mid) => setSearchString(mid)

  const updateMidStatus = () => {
    lazyFetchMidPayoutConfig(searchString)
  }

  return (
    <Box {...styles.container}>
      <Text {...styles.headerText}>Risk Controls</Text>
      <SpacerNew size={32} />
      <SearchByMid onClick={onSearchByMidClick} initialSearchMid={searchString} onMidChange={onMidChange} />

      <ModBox
        backgroundColor={'WHITE'}
        justifyContent={'center'}
        alignItems={'center'}
        pv={24}
        width={'60vw'}
        show={searchMidState === 'fulfilled'}
        borderBottomLeftRadius={16}
        borderBottomRightRadius={16}>
        <Details data={searchMerchantApiData} />
        <Spacer direction="vertical" size={16} />
        <Button onPress={updateMidStatus} disabled={!isAccessible(accessConfig, 'update')}>
          {fetchMidConfigState === 'pending' || updateState === 'pending' ? (
            <Loader color={'WHITE'} />
          ) : (
            <Text title={'Update'} color={'WHITE'} fontFamily={'jiotype-bold'} />
          )}
        </Button>
        <Spacer direction="vertical" size={16} />
      </ModBox>
      <ModBox
        show={searchMidState === 'pending'}
        position={'absolute'}
        top={0}
        left={0}
        right={0}
        bottom={0}
        justifyContent={'center'}>
        <LoaderNew color={'PRIMARY'} type={'large'} />
      </ModBox>
    </Box>
  )
}
const styles = {
  container: {
    h: '100%',
    bg: 'WHITE',
    shadowRadius: 8,
    shadowColor: '#0000001F' as ColorOptions,
    borderRadius: 8,
    p: 20,
    overflow: 'auto',
    alignContent: 'center',
    alignItems: 'center',
  } as BoxProps,
  headerText: {
    fontSize: 28,
    fontWeight: '600',
    color: '#5a5c69' as ColorOptions,
  } as TextProps,
}
export default RiskConfig
